<div class="col-sm-6 esquerda">
    <slider-midia [midias]="midias" class="area-midias"></slider-midia>
</div>

<div class="col-sm-6 direita">
    <div *ngIf="!showLoaderPerguntas">
        <progresso *ngIf="progresso > 0" [valor]="progresso"></progresso>

        <div class="container-perguntas">

            <div class="d-flex justify-content-between">
                <button (click)="backFunction()" mat-mini-fab color="basic" class="back-button">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                </button>

                <timer class="me-2" style="margin-top: 1em;" [inicio]="pergunta.inicio" [duracao]="pergunta.duracao"></timer>
            </div>

            <div>
                <div class="mt-4 descricao">
                    <p [innerHTML]="pergunta.descricao | safeHtmlJogada"></p>
                </div>

                <div class="mt-4">
                    Clique na alternativa que você considera ideal:
                </div>

                <alternativas-list [alternativas]="alternativas" [(value)]="alternativaSelecionada"></alternativas-list>

                <div *ngIf="alternativaSelecionada" class="mt-3">
                    <btn-continuar [texto]="'Responder'" (click)="confirmAlternativa()"></btn-continuar>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="showLoaderPerguntas">
        <div class="d-grid align-items-center justify-content-center">
            <loader-page [show]="true"></loader-page>
        </div>
    </div>
</div>